"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[5691],{

/***/ 35691:
/***/ ((module) => {

module.exports = JSON.parse('{"taskGroupSaved":"Mallgrupp sparad","somethingWentWrong":"Något gick fel!","pleaseTryAgainOrContactSupport":"Vänligen försök igen. Om problemet kvarstår, kontakta supporten.","taskGroupDeleted":"Mallgrupp borttagen"}');

/***/ })

}]);